import React, { useMemo } from 'react';
import EquipmentFamily from './EquipmentFamily';

const EquipmentFamilyForm = ({ models, documentGroupId }) => {
    const memoizedModels = useMemo(() => models, [models]);

    const memoizedRelationFilters = useMemo(() => ({
        "Document": [{
            field: "DocumentGroupId",
            operator: "is",
            type: "Number",
            value: documentGroupId
        }]
    }), [documentGroupId]);

    return (
        <EquipmentFamily.Form
            models={memoizedModels}
            relationFilters={memoizedRelationFilters}
        />
    );
};

export default React.memo(EquipmentFamilyForm);
